import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleSearchConsole = defineConnector({
  identifier: "googleSearchConsole",
  name: "Google Search Console",
  tagLine: "Search performance and indexing insights",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://www\\.googleapis\\.com/webmasters/.*|https://searchconsole\\.googleapis\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Set up Search Console API access",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Google Cloud Console](https://console.cloud.google.com/apis/credentials), create OAuth 2.0 credentials, and enable the **Search Console API**.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
          helperText: "A valid OAuth 2.0 access token.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.googleapis.com/webmasters/v3/sites",
  },
});
